import { generateSeoProps } from '../generateSeoProps';
export const getFaqSeoProps = () => {
	return generateSeoProps({
		title: 'FAQ: E-Learning & Pharma Career Support - Pharmuni',
		canonical: 'faq',
		description: 'Find answers on courses, GMP certificates, subscriptions & tech specs—get the info you need to grow your pharmaceutical career with Pharmuni.',
	});
};
